import axios from 'axios';
import http from '../../../http-common';

export default function requestLoadCasetasNew() {
    return http.get('/casetas');
}
